(function() {
  var BaseHandler, BaseOutput, DetailOutput,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DetailOutput = App.loadClass('core::reports/DetailOutput');

  BaseOutput = App.loadClass('core::reports/BaseOutput');

  BaseHandler = App.loadClass('core::reports/BaseHandler');

  exports.ReportsRuppOrdersSubHandler = (function(superClass) {
    extend(ReportsRuppOrdersSubHandler, superClass);

    function ReportsRuppOrdersSubHandler() {
      return ReportsRuppOrdersSubHandler.__super__.constructor.apply(this, arguments);
    }

    ReportsRuppOrdersSubHandler.prototype.init = function() {
      this.layoutSelector = '#reports_rupp_orders_tab';
      this.layoutUrl = 'backend/portal/reports/rupp-orders/table/detail';
      this.excelUrl = 'backend/portal/reports/rupp-orders/excel';
      this.filterUrl = 'backend/portal/reports/rupp-orders/filters';
      this.currentOutput = new DetailOutput(this, this.parent, 'auto', {
        sAjaxSource: 'backend/portal/reports/rupp-orders/output/detail'
      });
      return this.initFilters();
    };

    ReportsRuppOrdersSubHandler.prototype.initFilters = function() {
      var year;
      this.resetFilters();
      this.parent.filters.removeGroup('Region Filters');
      this.parent.filters.removeGroup('Operation Filters');
      this.parent.filters.importGroup({
        name: 'Orders Filters',
        filters: [
          {
            name: 'categories',
            display_name: 'Item Category',
            "class": 'dropup'
          }, {
            name: 'years',
            display_name: 'Sales Year',
            "class": 'dropup'
          }, {
            name: 'states',
            display_name: 'State',
            "class": 'dropup'
          }, {
            name: 'zips',
            display_name: 'ZIP Code',
            "class": 'dropup'
          }, {
            name: 'zones',
            display_name: 'Pricing Zone',
            "class": 'dropup'
          }, {
            name: 'reps',
            display_name: 'Sales Rep',
            "class": 'dropup'
          }, {
            name: 'operations',
            display_name: 'Company',
            "class": 'dropup'
          }, {
            name: 'customers',
            display_name: 'Customer',
            "class": 'dropup'
          }, {
            name: 'orders',
            display_name: 'Order #',
            "class": 'dropup'
          }, {
            name: 'trait_packages',
            display_name: 'Trait Package',
            "class": 'dropup'
          }, {
            name: 'products',
            display_name: 'Product',
            "class": 'dropup'
          }, {
            name: 'treatments',
            display_name: 'Treatment',
            "class": 'dropup'
          }, {
            name: 'units_of_measure',
            display_name: 'UoM',
            "class": 'dropup'
          }, {
            name: 'start_date',
            display_name: 'Delivery Start Date',
            control_type: 'datepicker'
          }, {
            name: 'end_date',
            display_name: 'Delivery End Date',
            control_type: 'datepicker'
          }
        ]
      });
      year = this.parent.filters.findInGroup('years');
      year.control_type = 'single_dropdown';
      year.deletable = false;
      return this.setDefaultsAndRun(0, 5, 17);
    };

    ReportsRuppOrdersSubHandler.prototype.destroy = function() {
      this.parent.filters.removeGroup('Orders Filters');
      this.importDefaultFilters();
      return ReportsRuppOrdersSubHandler.__super__.destroy.call(this);
    };

    return ReportsRuppOrdersSubHandler;

  })(BaseHandler);

}).call(this);
